import { Component, OnInit, OnChanges, Input, Output, NgZone, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { take } from 'rxjs/operators';
import { LocationHotelBusinessService } from '../../services/location-hotel-business.service';
import moment from 'moment';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-location-hotel-business-lookup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './location-hotel-business-lookup.component.html',
  styleUrls: ['./location-hotel-business-lookup.component.scss'],
  providers: [LocationHotelBusinessService]
})
export class LocationHotelBusinessLookupComponent implements OnInit, OnChanges {

  private _enteredValue: string;
  private _lastEnteredValue = '';
  private _timeout;

  public items: Array<Object> = [];
  public selected: Boolean = false;
  public current: any = 0;
  public locationItem: String = '';
  public showLoader: Boolean = false;
  public errorHotelLocation = false; // use this check to show error for zero result
  public requestedDateTime = '';
  public hoursDifference = 0;
  public destinationAirportCode = '';
  public bookingProduct;
  public flightDirection;
  public departureAirlineCode;
  public arrivalAirlineCode;

  private airportCode;
  private departureCountryCode;
  private arrivalCountryCode;

  @Input()
  bookingType;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  selectedLocationType;

  @Input()
  placeholder;

  @Input()
  selectedAddress;

  @Input()
  errorSubmitEmpty;

  @Input()
  errorNoPostcode;

  @Input()
  errorPostcodeOutsideZone;

  @Output()
  changedAddressLine: EventEmitter<any> = new EventEmitter();

  @Output()
  selectedLocation: EventEmitter<any> = new EventEmitter();

  @Output()
  clearInput: EventEmitter<any> = new EventEmitter();

  @Output()
  toggleShowMenu: EventEmitter<any> = new EventEmitter();

  constructor(
    private _LocationHotelBusinessService: LocationHotelBusinessService,
    private _ngZone: NgZone,
    private _appStore: Store<AppState>,
  ) { }

  ngOnInit() {
    const state = this.getState(this._appStore);
    const flightData = state.flightReducer.flightDetails.flightResponse;
    this.bookingProduct = state.bookingReducer.bookingDetails.bookingProduct;
    this.flightDirection = state.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;
    this.departureCountryCode = flightData.flightStatusDetails[0].departureAirport.airportCountryCode;
    this.arrivalCountryCode = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCountryCode;
    this.locationItem = this.selectedAddress.name;

    this.departureAirlineCode =  this.flightDirection === 1 ? flightData.flightStatusDetails[0].departureAirport.airportCode : null;
    this.arrivalAirlineCode =  this.flightDirection === 2 ? flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode : null;

    this.requestedDateTime = flightData.flightInfo.requestedDateTime;

    let date1 = moment();
    let date2 = moment(this.requestedDateTime)
    this.hoursDifference = date2.diff(date1, 'hours');

    const departureCountryCode = flightData.flightStatusDetails[0].departureAirport.airportCode;
    const arrivalCountryCode = flightData.flightStatusDetails[flightData.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    this.airportCode = this.bookingProduct === 'abc' ? departureCountryCode : arrivalCountryCode;

    this._LocationHotelBusinessService.hotelBusinessLocations$
      .subscribe(res => {
        if (res === 'ZERO_RESULTS') {
          this.errorHotelLocation = true;
          return
        }
        this._ngZone.run(() => {
          this.items = res;
          this.showLoader = false;
        });
      },
        err => {
          // console.log(err, 'err')
        }
      );
  }

  handleClearInput() {
    this.valueChange('');
    this.clearInput.emit();
    this.errorHotelLocation = false;
  }

  valueChange(value) {
    this.changedAddressLine.emit(value);

    this.selected = false;
    this._enteredValue = value;
    this.items = [];
    this.showLoader = false;
    this.errorHotelLocation = false;
    if (this._enteredValue !== this._lastEnteredValue && this._enteredValue.length > 2) {

      this.showLoader = true;
      this._lastEnteredValue = this._enteredValue;

      if (this._timeout) { clearTimeout(this._timeout); }

      this._timeout = setTimeout(() => {
        this.callApi();
      }, 500);
    }

  }

  callApi() {
    const countryCode = this.bookingProduct === 'ccd' ? this.arrivalCountryCode : this.departureCountryCode;
    this._LocationHotelBusinessService.getLocationData(this._enteredValue, countryCode);
  }

  setCurrent(index) {
    this.current = index;
  }

  isCurrent(index) {
    return this.current === index;
  };

  selectItem() {
    const selectedItem = this.items[this.current];
    this.handleSelection(selectedItem);
  };

  handleSelection(selectedItem) {
    if (typeof selectedItem !== 'undefined') {
      this.selected = true;
      this.showLoader = true;
      this.locationItem = selectedItem.description;
      this.selectedLocation.emit({selectedItem, airportCode: this.airportCode});
      this.toggleShowMenu.emit(false);
    }
  }

  updateSelection(e) {

    // down key
    if (e.which === 40) {
      this.current = (this.current + 1) % this.items.length;
    } else if (e.which === 38) {
      // up key
      this.current = (this.current ? this.current : this.items.length) - 1;
    } else if (e.which === 13) {
      // enter key
      e.preventDefault();
      this.selectItem();
    }

  }

  close() {
    this.items = [];
  }
  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnChanges(changes: any) {
    this.showLoader = false;

    if (typeof changes.selectedAddress === 'undefined') {
      return;
    }

    this._ngZone.run(() => {
      this.locationItem = changes.selectedAddress.currentValue.name;
    });
  }

}
